function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { Component } from 'react';
let colors = {};
export function getRandomColor(opacity = 1) {
  const color = 'rgba(' + (Math.floor(Math.random() * 106) + 150) + ', ' + (Math.floor(Math.random() * 106) + 150) + ', ' + (Math.floor(Math.random() * 106) + 150) + ', ' + opacity + ')';
  if (colors.hasOwnProperty(color)) {
    return getRandomColor();
  }
  colors[color] = null;
  return color;
}

/**
 * @component 
 * @description
 * Generates a colorful UI component
 *
 * @see GRID_REPO_URL - Documentation
 *
 * @extends {Component<PlaceholderProps>}
 * @returns {JSX.Element} JSX Element
 * 
 * @example
 * <Column gap="sm" xs="auto 1fr">
 *     <Placeholder>Header</Placeholder>
 *     <Placeholder>Section 1</Placeholder>
 *     <Placeholder>Section 2</Placeholder>
 * </Row>
 *
 */
class Placeholder extends Component {
  /**
   * @typedef {Object}    PlaceholderProps
   * @prop {string}       [color=random]       - Use a static color for the placeholder background
   * @memberof Placeholder
   */
  static defaultProps = {
    color: getRandomColor()
  };
  state = {
    color: this.props.color
  };
  render() {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: "layout-placeholder"
    }, this.props, {
      style: {
        backgroundColor: this.state.color,
        display: 'flex',
        whiteSpace: 'nowrap',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: "1em",
        minWidth: "min-content",
        color: 'black',
        ...this.props.style
      }
    }), this.props.children);
  }
}
export default Placeholder;